import { createFileRoute } from "@tanstack/react-router";
import PartnersBadge from "@/pages/PartnersBadge";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/parteneri/badge/")({
  head: () => routeHead("/parteneri/badge/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <PartnersBadge />
  );
}
